// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 17:53:06

export default {
  "id": "mermaid-princess-avater-castle",
  "slug": "mermaid-princess-avater-castle",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/7077589ce4a44e888f0f44dff6497580-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/7077589ce4a44e888f0f44dff6497580/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Mermaid Princess Avater Castle",
      "description": "This is a dress-up and decorating game for girls. If you like games where you create your world, you can't miss our game. There is a group of mermaids living in the underwater world and you can live with them and create beautiful memories.",
      "instructions": "Mouse click or tap to play\n",
      "genres": [
        "Dress-up"
      ],
      "tags": [
        "decoration",
        "girls",
        "mermaid",
        "underwater"
      ]
    },
    "zh-CN": {
      "title": "人鱼公主幻境城堡",
      "description": "这是一款女孩的装扮与装饰游戏。如果你喜欢创造自己世界的游戏，那你就不能错过我们的游戏。有一群美人鱼生活在海底世界，你可以和她们一起生活，创造美好的回忆。",
      "instructions": "鼠标点击或轻触开始游戏",
      "genres": [
        "装扮"
      ],
      "tags": [
        "装饰",
        "女孩",
        "人鱼",
        "水下"
      ]
    },
    "zh-TW": {
      "title": "人魚公主阿瓦塔城堡",
      "description": "這是一款為女孩設計的裝扮和裝飾遊戲。如果你喜歡創造自己的世界，絕對不能錯過我們的遊戲。有一群美人魚居住在海底世界，你可以和他們一起生活，創造美麗的回憶。",
      "instructions": "滑鼠點擊或觸控開始遊戲",
      "genres": [
        "装扮"
      ],
      "tags": [
        "裝飾",
        "女孩",
        "人魚",
        "海底"
      ]
    },
    "zh-HK": {
      "title": "人魚公主化身城堡",
      "description": "這是一款為女仔設計的打扮及裝飾遊戲。如果你喜歡創造自己世界的遊戲，絕對不會錯過我們的遊戲。有一群人魚居住在海底世界，你可以和他們一起生活，並創造美麗的回憶。",
      "instructions": "滑鼠點擊或觸控開始遊戲",
      "genres": [
        "打扮"
      ],
      "tags": [
        "裝飾",
        "女孩",
        "人魚",
        "海底"
      ]
    },
    "ja": {
      "title": "人魚姫アバター城",
      "description": "これは女の子向けのドレスアップと装飾ゲームです。自分の世界を作るゲームが好きな場合は、私たちのゲームは見逃せません。海の下の世界に住む人魚たちのグループがあり、彼らと一緒に暮らし、美しい思い出を作ることができます。",
      "instructions": "マウスクリックまたはタップで遊ぶ",
      "genres": [
        "ドレスアップ"
      ],
      "tags": [
        "装飾",
        "女の子",
        "人魚",
        "水中"
      ]
    },
    "ko": {
      "title": "미쥐사공주 아바터 성堡",
      "description": "이는 여자아이들을 위한 드레스업과 장식 게임입니다. 자신만의 세계를 만들어보는 게임을 좋아한다면, 우리 게임을 놓치지 마세요. 바닥 아래 세계에 살고 있는 항해사 여자들이 있으며, 그들과 함께 살고 아름다운 기억을 만들 수 있습니다.",
      "instructions": "마우스 클릭 또는 탭하여 게임 시작",
      "genres": [
        "드레스업"
      ],
      "tags": [
        "장식",
        "소녀",
        "인어",
        "바닥 아래"
      ]
    },
    "fr": {
      "title": "Princessette Sirène Château d'Avatar",
      "description": "C'est un jeu de déguisement et de décoration pour les filles. Si vous aimez les jeux où vous créez votre monde, vous ne pouvez pas rater notre jeu. Il y a un groupe de sirènes vivant dans le monde sous-marin et vous pouvez vivre avec elles et créer de beaux souvenirs.",
      "instructions": "Cliquez sur la souris ou appuyez pour jouer",
      "genres": [
        "Dress-up"
      ],
      "tags": [
        "décoration",
        "filles",
        "sirène",
        "sous-marine"
      ]
    }
  }
};
